export const SET_ACTIVE_CLINIC = 'SET_ACTIVE_CLINIC'
export function setActiveClinic(payload) {
  return {
    type: SET_ACTIVE_CLINIC,
    payload
  }
}

export const SET_PATIENT_AT_CLINIC_DETAILS = 'SET_PATIENT_AT_CLINIC_DETAILS'
export function setPatientDetailsAtClinic(payload) {
  return {
    type: SET_PATIENT_AT_CLINIC_DETAILS,
    payload
  }
}

export const SET_APPOINTMENT_DETAILS = 'SET_APPOINTMENT_DETAILS'
export function setAppointmentDetails(payload) {
  return {
    type: SET_APPOINTMENT_DETAILS,
    payload
  }
}

export const TOGGLE_APPOINTMENT_MESSAGE = 'TOGGLE_APPOINTMENT_MESSAGE'
export function toggleAppointmentMessage() {
  return {
    type: TOGGLE_APPOINTMENT_MESSAGE
  }
}

export const TOGGLE_MEGOLI_APPOINTMENT_MESSAGE = 'TOGGLE_MEGOLI_APPOINTMENT_MESSAGE'
export function toggleMegoliAppointmentMessage() {
  return {
    type: TOGGLE_MEGOLI_APPOINTMENT_MESSAGE
  }
}

export const CLEAR_APPOINTMENT_STATE = 'CLEAR_APPOINTMENT_STATE'
export function clearAppointmentState() {
  return {
    type: CLEAR_APPOINTMENT_STATE
  }
}

export const SET_APPOINTMENT_STAGE = 'SET_APPOINTMENT_STAGE'
export function setAppointmentStage(payload) {
  return {
    type: SET_APPOINTMENT_STAGE,
    payload
  }
}

export const SET_APPOINTMENT_IS_ONLINE = 'SET_APPOINTMENT_IS_ONLINE'
export function setAppointmentIsOnline(payload) {
  return {
    type: SET_APPOINTMENT_IS_ONLINE,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_MODE = 'SET_APPOINTMENTS_BOOKING_MODE'
export function setAppointmentsBookingMode(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_MODE,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_STEP = 'SET_APPOINTMENTS_BOOKING_STEP'
export function setAppointmentsBookingStep(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_STEP,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_FORM = 'SET_APPOINTMENTS_BOOKING_FORM'
export function setAppointmentsBookingForm(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_FORM,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_SPECIALTIES = 'SET_APPOINTMENTS_BOOKING_SPECIALTIES'
export function setAppointmentsBookingSpecialties(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_SPECIALTIES,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_CLINICS = 'SET_APPOINTMENTS_BOOKING_CLINICS'
export function setAppointmentsBookingClinics(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_CLINICS,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_PROFESSIONALS = 'SET_APPOINTMENTS_BOOKING_PROFESSIONALS'
export function setAppointmentsBookingProfessionals(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_PROFESSIONALS,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_SUBMITTED_FILTERS =
  'SET_APPOINTMENTS_BOOKING_SUBMITTED_FILTERS'
export function setAppointmentsBookingSubmittedFilters(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_SUBMITTED_FILTERS,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_SEARCH_RESULTS =
  'SET_APPOINTMENTS_BOOKING_SEARCH_RESULTS'
export function setAppointmentsBookingSearchResults(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_SEARCH_RESULTS,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_SEARCH_FETCHED =
  'SET_APPOINTMENTS_BOOKING_SEARCH_FETCHED'
export function setAppointmentsBookingSearchFetched(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_SEARCH_FETCHED,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_SELECTED_APPOINTMENTS =
  'SET_APPOINTMENTS_BOOKING_SELECTED_APPOINTMENTS'
export function setAppointmentsBookingSelectedAppointments(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_SELECTED_APPOINTMENTS,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_SELECTED_SPECIALTY_TAB =
  'SET_APPOINTMENTS_BOOKING_SELECTED_SPECIALTY_TAB'
export function setAppointmentsBookingSelectedSpecialtyTab(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_SELECTED_SPECIALTY_TAB,
    payload
  }
}

export const SET_APPOINTMENTS_BOOKING_SELECTED_TURN =
  'SET_APPOINTMENTS_BOOKING_SELECTED_TURN'
export function setAppointmentsBookingSelectedTurn(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_SELECTED_TURN,
    payload
  }
}

export const ADD_APPOINTMENTS_BOOKING_CART_TURN = 'ADD_APPOINTMENTS_BOOKING_CART_TURN'
export function addAppointmentsBookingCartTurn(payload) {
  return {
    type: ADD_APPOINTMENTS_BOOKING_CART_TURN,
    payload
  }
}

export const REMOVE_APPOINTMENTS_BOOKING_CART_TURN =
  'REMOVE_APPOINTMENTS_BOOKING_CART_TURN'
export function removeAppointmentsBookingCartTurn(payload) {
  return {
    type: REMOVE_APPOINTMENTS_BOOKING_CART_TURN,
    payload
  }
}

export const CLEAR_APPOINTMENTS_BOOKING_CART = 'CLEAR_APPOINTMENTS_BOOKING_CART'
export function clearAppointmentsBookingCart() {
  return {
    type: CLEAR_APPOINTMENTS_BOOKING_CART
  }
}

export const SET_APPOINTMENTS_BOOKING_RESULT = 'SET_APPOINTMENTS_BOOKING_RESULT'
export function setAppointmentsBookingResult(payload) {
  return {
    type: SET_APPOINTMENTS_BOOKING_RESULT,
    payload
  }
}

export const RESET_APPOINTMENTS_BOOKING_STATE = 'RESET_APPOINTMENTS_BOOKING_STATE'
export function resetAppointmentsBookingState() {
  return {
    type: RESET_APPOINTMENTS_BOOKING_STATE
  }
}